
export class TableUtils {
  static decimalDigits: number = 2;
  static percentDecimals: number = 1;

  static formatCurrency(value: number | null): string {
    return this.formatDecimal(value, this.decimalDigits, { minDecimals: this.decimalDigits });
  }

  static formatDecimal(
    value: number | string | null | undefined,
    maxDecimals: number = 2,
    options?: { minDecimals?: number; emptyPlaceholder?: string }
  ): string {
    if (value == null || value === '') return options?.emptyPlaceholder ?? '-';
    const num = Number(value);
    if (Number.isNaN(num)) return String(value);
    return num.toLocaleString('de-DE', {
      minimumFractionDigits: options?.minDecimals ?? 0,
      maximumFractionDigits: maxDecimals
    });
  }
  
  static amountsMatch(a: number, b: number): boolean {
    const factor = Math.pow(10, this.decimalDigits);
    return Math.round(a * factor) === Math.round(b * factor);
  }

  static getValidationClass(status: 'valid' | 'invalid' | null | undefined): string | null {
    if (status === 'valid') {
      return 'validation-valid';
    }
    if (status === 'invalid') {
      return 'validation-invalid';
    }
    return null;
  }

  static getYearPart(label: string): string {
    if (!label) {
      return '';
    }
    const match = new RegExp(/\d{2}\/\d{2}/).exec(label);
    return match ? match[0] : '';
  }

  static getLabelWithoutYear(label: string): string {
    if (!label) {
      return '';
    }
    const year = this.getYearPart(label);
    if (!year) {
      return label;
    }
    return label.replace(year, '').trim();
  }

  static formatDate(date: any): string {
    if (!date) return '-';
    const d = new Date(date);
    if (Number.isNaN(d.getTime())) return '-';
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  }
}